import { IDatatype } from "@/api/datatypes";
import { Visibility } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useDialogs } from "@toolpad/core";
import { DatatypeSchemaDialog } from "./DatatypeSchemaDialog";

interface IProps {
    datatype: IDatatype;
}

export const DatatypeSchemaButton = ({ datatype }: IProps) => {
    const dialogs = useDialogs();

    const handleView = async () => {
        await dialogs.open(DatatypeSchemaDialog, { datatype });
    };

    if (!datatype.datatype_schema || datatype.datatype_schema.length === 0) {
        return null;
    }

    return (
        <GridActionsCellItem
            icon={
                <Tooltip title="View Schema">
                    <Visibility />
                </Tooltip>
            }
            label="View Schema"
            onClick={handleView}
        />
    );
};
